import {BoxId, SheetId} from '@mintdata-wsp/mint-kit/api/models/Identifiers';
import {Point} from '@mintdata-wsp/mint-kit/api/models/Point';
import {PageId} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/Page';
import {FocusedArea} from '@mintdata-wsp/common/state/ui/visualDesigner/workbench/WorkbenchState';

export const DEFAULT_DESIGN_UI_STATE:IDesignUIState = {
    workbench: {
        focusedArea: FocusedArea.None,
        visibility: {
            isSpreadsheetVisible: true,
            isSpreadsheetFullScreen: false,
            isPropertiesPanelVisible: false,
            isPagesPanelVisible: false,
            layout: {
                gridLeftColumnWidthPx: 325,
                gridRightColumnWidth: 38.2,
                frameDetailsContainerHeight: 50,
                isSurfaceCopyPagesPanelShown: false,
                isSurfacePagesOutlinePanelCollapsed: false,
                isSurfaceComponentsPanelCollapsed: false,
                isSurfaceBoxesOutlinePanelCollapsed: false,
                surfaceCopyPagesPanelHeight: 0,
                surfaceCopyPagesPanelExpandedPartHeightPx: 0,
                surfacePagesOutlinePanelHeight: 20,
                surfaceComponentsPanelHeight: 38,
                surfaceBoxesOutlinePanelHeight: 42,
            }
        },
        cellSettingsBar: {
            isBarVisible: true
        }
    },
    topMenu: {
        isExpanded: true
    },
    surfaceArea: {
        selectionState: {
            selectedBoxesIdsByPage: null,
        },
        panModeState: {
            position: {
                x: 0,
                y: 0,
            }
        },
        zoom: 1
    },
    surfaceUi: {
        activePageId: null,
    },
    meshState: {
        isGridlinesVisible: true,
        details: {
            activeCell: {
                colIndex: 0,
                rowIndex: 0
            },
            selectionRangeFrom: {
                colIndex: 0,
                rowIndex: 0
            },
            selectionRangeTo: {
                colIndex: 0,
                rowIndex: 0
            },
            scrollLeft: 0,
            scrollTop: 0
        }
    },
    spreadsheetTabsState: {
        activeSheetId: null,
    }
}

/**
 * Workbench
 */
 export interface IVisualDesignerLayoutState
 {
     gridLeftColumnWidthPx?:number;
     gridRightColumnWidth?:number;
     frameDetailsContainerHeight?:number;
     isSurfaceCopyPagesPanelShown?:boolean;
     isSurfacePagesOutlinePanelCollapsed?:boolean;
     isSurfaceComponentsPanelCollapsed?:boolean;
     isSurfaceBoxesOutlinePanelCollapsed?:boolean;
     surfaceCopyPagesPanelHeight?:number; // in percent
     surfaceCopyPagesPanelExpandedPartHeightPx?:number; // in pixels
     surfacePagesOutlinePanelHeight?:number; // in percent
     surfaceComponentsPanelHeight?:number; // in percent
     surfaceBoxesOutlinePanelHeight?:number;
 }

 export interface IWorkbenchDesignUIState
 {
     focusedArea?:FocusedArea;
     visibility?: {
         isSpreadsheetVisible?:boolean;
         isSpreadsheetFullScreen?:boolean;
         isPropertiesPanelVisible?:boolean;
         isPagesPanelVisible?:boolean;
         layout?:IVisualDesignerLayoutState;
     };
     cellSettingsBar?: {
         isBarVisible?:boolean;
     };
 }

/**
 * Top Menu
 */
 export interface ITopMenuDesignUIState
 {
     isExpanded?:boolean;
 }

/**
 * Surface Area
 */
export interface ISelectionDesignUIState
{
    selectedBoxesIdsByPage?:Map<PageId, Array<BoxId>>;
}

export interface IPanModeDesignUIState
{
    position?:Point;
}

export interface ISurfaceAreaDesignUIState
{
    selectionState?:ISelectionDesignUIState;
    panModeState?:IPanModeDesignUIState;
    zoom?:number;
}

/**
 * Surface UI
 */
export interface ISurfaceUiDesignUIState
{
    activePageId?:PageId;
}

/**
 * Mesh State
 */
export interface IMeshLocation
{
    colIndex?:number;
    rowIndex?:number;
} 

export interface IMeshStateDetailsDesignUIState
{
    activeCell?:IMeshLocation;
    selectionRangeFrom?:IMeshLocation;
    selectionRangeTo?:IMeshLocation;
    scrollLeft?:number;
    scrollTop?:number;
}  

export interface IMeshStateDesignUIState
{
    isGridlinesVisible?:boolean;
    details?:IMeshStateDetailsDesignUIState;
}

/**
 * Tabs state
 */
export interface ISpreadsheetTabsDesignUIState
{
    activeSheetId?:SheetId;
}

export interface IDesignUIState
{
    // panels visibility, widths & heights
    workbench?:IWorkbenchDesignUIState;

    // is expanded?
    topMenu?:ITopMenuDesignUIState;

    // zoom, pan, selection
    surfaceArea?:ISurfaceAreaDesignUIState;

    // active page
    surfaceUi?:ISurfaceUiDesignUIState;

    // gridlines, details: selection, scroll position
    meshState?:IMeshStateDesignUIState;

    // active sheet
    spreadsheetTabsState?:ISpreadsheetTabsDesignUIState;
}